module.exports = __webpack_public_path__ + "static/media/icon-calculator.8e4a5574.svg";